import "../sass/style.scss";
import "./sliderConfigs.js";
import "./mouseParallax.js";
import "./ui-interactions.js";
import "./formControls.js";
import "./queryParts.js";
import "./stepForm.js";
import "./uploadPreview.js";
import "./lightBox.js";
import "./displayDynamicFields.js";

// import "./helpers/handleForms.js";

(function ($) {
  $(".generic-submit-btn").on("click", function (event) {
    event.preventDefault();

    var form = $(this).closest("form")[0];
    var formTree = $(this).closest("form");
    var button = $(this);

    // Check CAPTCHA if required
    // var is_single = $(form).find("input[name=is_single]").val() || 0;
    // if (!is_single && grecaptcha.getResponse() === "") {
    //   $(formTree)
    //     .find("#error-message")
    //     .html("Please check the CAPTCHA")
    //     .removeClass("d-none");
    //   setTimeout(() => {
    //     $(formTree).find("#error-message").addClass("d-none");
    //   }, 5000);
    //   return;
    // }

    // Show spinner and hide button text
    button.find(".spinner-overlay").css("display", "flex");
    button.find(".btn-text").css("display", "none");

    $(form).addClass("was-validated");

    if (form.checkValidity() === false) {
      event.stopPropagation();
      button.find(".spinner-overlay").css("display", "none");
      button.find(".btn-text").css("display", "block");
      return;
    }

    var formData = new FormData(form);

    $.ajax({
      url: lmcl.ajax_url,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: function (response) {
        const data = response.data;

        // Hide spinner and show button text
        button.find(".spinner-overlay").css("display", "none");
        button.find(".btn-text").css("display", "block");

        if (response.success && data.error.status === 0) {
          form.reset();
          $(form).removeClass("was-validated");

          // Show success message
          // $(formTree)
          //   .find("#success-message")
          //   .html(data.response)
          //   .removeClass("d-none");
          // setTimeout(() => {
          //   $(formTree).find("#success-message").addClass("d-none");
          // }, 5000);

          // Show success modal
          const successModal = new bootstrap.Modal(
            document.getElementById("successModal")
          );
          successModal.show();
        } else {
          // Show error messages as toasts
          const errors = data.errors || [];
          console.log(data);
          console.log("errors", errors);
          errors.forEach((error) => {
            const toast = $(`
              <div class="toast align-items-center text-bg-danger my-2 border-0" role="alert" aria-live="assertive" aria-atomic="true">
                  <div class="d-flex">
                      <div class="toast-body text-white">
                          ${error}
                      </div>
                      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                  </div>
              </div>
            `);

            $("#toast-container").append(toast);

            toast.toast({ delay: 5000 });
            toast.toast("show");

            toast.on("hidden.bs.toast", function () {
              $(this).remove();
            });
          });

          // Optional: Show errors in the error field
          $(formTree)
            .find("#error-message")
            .html(
              "<ul>" + errors.map((e) => `<li>${e}</li>`).join("") + "</ul>"
            )
            .removeClass("d-none");

          setTimeout(() => {
            $(formTree).find("#error-message").addClass("d-none");
          }, 5000);
        }

        // Reset CAPTCHA if required
        if (!is_single) {
          grecaptcha.reset();
        }
      },
      error: function (response) {
        // Handle AJAX errors
        $(formTree)
          .find("#error-message")
          .html(response.responseJSON.message)
          .removeClass("d-none");

        setTimeout(() => {
          $(formTree).find("#error-message").addClass("d-none");
        }, 5000);

        // Reset CAPTCHA if required
        if (!is_single) {
          grecaptcha.reset();
        }

        // Hide spinner and show button text
        button.find(".spinner-overlay").css("display", "none");
        button.find(".btn-text").css("display", "block");
      },
    });
  });

  // -----------------------------
  // Shared OTP helpers (used only for sell/exchange forms)
  // -----------------------------
  const otpModalEl = document.getElementById("otpModal");
  const otpModalInstance = otpModalEl ? new bootstrap.Modal(otpModalEl) : null;
  let otpTimer = null;
  let otpSeconds = 0;
  const pendingOtp = {
    formData: null,
    button: null,
    form: null,
    formTree: null,
    token: null,
    formType: null,
    email: null,
    onVerified: null,
  };

  function setOtpEmailPlaceholder(email) {
    const masked =
      email && email.includes("@")
        ? email.replace(/(.{2}).+(@.+)/, "$1***$2")
        : email;
    $("#otpModal .otp-email-placeholder").text(masked || "");
  }

  function resetOtpFields() {
    $("#otpModal .otp-field").val("");
    $("#otpModal .otp-field").first().focus();
    $("#resendBtn").addClass("d-none");
    $("#resendTimer").text("");
  }

  function startResendTimer() {
    otpSeconds = 60;
    $("#resendBtn").addClass("d-none");
    $("#resendTimer").text(`Resend available in ${otpSeconds}s`);
    if (otpTimer) {
      clearInterval(otpTimer);
    }
    otpTimer = setInterval(() => {
      otpSeconds -= 1;
      if (otpSeconds <= 0) {
        clearInterval(otpTimer);
        $("#resendTimer").text("");
        $("#resendBtn").removeClass("d-none");
      } else {
        $("#resendTimer").text(`Resend available in ${otpSeconds}s`);
      }
    }, 1000);
  }

  function startOtpFlow(formEl, formDataObj, buttonEl, formTreeObj, onVerified) {
    // If OTP modal not present (e.g. some templates), just proceed normally
    if (!otpModalInstance) {
      onVerified(formDataObj);
      return;
    }

    const email = $(formEl).find("[name='seller_email']").val();
    const formType = formDataObj.get("form_type");

    pendingOtp.formData = formDataObj;
    pendingOtp.button = buttonEl;
    pendingOtp.form = formEl;
    pendingOtp.formTree = formTreeObj;
    pendingOtp.formType = formType;
    pendingOtp.email = email;
    pendingOtp.onVerified = onVerified;

    $.ajax({
      url: lmcl.ajax_url,
      type: "POST",
      data: {
        action: "send_otp",
        email: email,
        form_type: formType,
      },
      success: function (resp) {
        const data = resp.data;
        pendingOtp.token = data.token;
        setOtpEmailPlaceholder(email);
        resetOtpFields();
        startResendTimer();
        // keep spinner running while OTP is in progress
        otpModalInstance.show();
      },
      error: function () {
        buttonEl.querySelector(".spinner-overlay").style.display = "none";
        buttonEl.querySelector(".btn-text").style.display = "block";
        $(formTreeObj)
          .find("#error-message")
          .html("Failed to send OTP. Please try again.")
          .removeClass("d-none");
        setTimeout(() => {
          $(formTreeObj).find("#error-message").addClass("d-none");
        }, 5000);
      },
    });
  }

  // OTP input auto-advance and auto-verify on 4 digits
  $("#otpModal .otp-field")
    .off("input.otp")
    .on("input.otp", function () {
      let value = $(this).val().replace(/[^0-9]/g, "");
      $(this).val(value);

      if (value.length === 1) {
        $(this).next(".otp-field").focus();
      }

      const code = $("#otpModal .otp-field")
        .map(function () {
          return $(this).val();
        })
        .get()
        .join("")
        .trim();

      if (code.length !== 4 || !pendingOtp.token) {
        return;
      }

      $.ajax({
        url: lmcl.ajax_url,
        type: "POST",
        data: {
          action: "verify_otp",
          token: pendingOtp.token,
          code: code,
          email: pendingOtp.email,
          form_type: pendingOtp.formType,
        },
        success: function (resp) {
          const data = resp.data;
          pendingOtp.formData.append("otp_verified_token", data.verified_token);
          if (otpModalInstance) {
            otpModalInstance.hide();
          }
          if (typeof pendingOtp.onVerified === "function") {
            pendingOtp.onVerified(pendingOtp.formData);
          }
        },
        error: function () {
          $("#otpModal .resend-wrap").append(
            '<div class="text-danger mt-2">Invalid or expired code.</div>'
          );
        },
      });
    });

  $("#resendBtn")
    .off("click.otp")
    .on("click.otp", function () {
      if (!pendingOtp.email || !pendingOtp.formType) return;
      startOtpFlow(
        pendingOtp.form,
        pendingOtp.formData,
        pendingOtp.button,
        pendingOtp.formTree,
        pendingOtp.onVerified
      );
    });

  // Sell Leads / used cars / new car form controls
  $(
    "form[name='sellLeads'], form[name='used_car_exform'], form[name='new_car_exform']"
  ).on("submit", function (event) {
    event.preventDefault();
    console.log("sellLeads form triggered!");
    var form = $(this)[0];
    var formTree = $(this);
    var formData = new FormData();
    var button = document.querySelector(".submit-sellcar");
    button.querySelector(".spinner-overlay").style.display = "flex";
    button.querySelector(".btn-text").style.display = "none";

    var turnstileResponse = $('[name="cf-turnstile-response"]').val();

    if (!turnstileResponse) {
      $(formTree)
        .find("#error-message")
        .html("Please complete the CAPTCHA")
        .removeClass("d-none");

      setTimeout(() => {
        $(formTree).find("#error-message").addClass("d-none");
      }, 5000);

      return;
    }

    // Append Turnstile response to FormData (if not already auto-included)
    formData.append("cf-turnstile-response", turnstileResponse);

    var imageFiles = $(form).find("[name='images[]']")[0].files;

    if (imageFiles.length > 0) {
      for (var i = 0; i < imageFiles.length; i++) {
        formData.append("images[]", imageFiles[i]);
      }
    }

    // form fields to append in used car form
    if (form.name == "used_car_exform") {
      formData.append("make", $(form).find("[name='make']").val());
      // model field set
      var modelSelectVal = $(form).find("select[name='model']").val();
      // var modelInputVal = $(form).find("input[name='model']").val().trim();
      var modelInputVal = null;
      if (modelSelectVal && modelSelectVal.trim() !== "") {
        formData.append("model", modelSelectVal);
      } else if (modelInputVal && modelInputVal !== "") {
        formData.append("model", modelInputVal);
      }

      // Variant Field Selection
      var varientSelectVal = $(form).find("select[name='varient']").val();
      // var varientInputVal = $(form).find("input[name='varient']").val().trim();
      var varientInputVal = null;
      if (varientSelectVal && varientSelectVal.trim() !== "") {
        formData.append("varient", varientSelectVal);
      } else if (varientInputVal && varientInputVal !== "") {
        formData.append("varient", varientInputVal);
      }

      formData.append("year", $(form).find("[name='year']").val());
      formData.append("mileage", $(form).find("[name='mileage']").val());
      // formData.append("images[]", $(form).find("[name='images[]']").val());
      formData.append("message", $(form).find("[name='message']").val());
      formData.append(
        "seller_name",
        $(form).find("[name='seller_name']").val()
      );
      formData.append(
        "seller_email",
        $(form).find("[name='seller_email']").val()
      );
      formData.append(
        "seller_phone",
        $(form).find("[name='seller_phone']").val()
      );
      formData.append(
        "seller_pref_contact",
        $(form).find("[name='seller_pref_contact']").val()
      );
      formData.append(
        "seller_city",
        $(form).find("[name='seller_city']").val()
      );
      formData.append("condition", $(form).find("[name='condition']").val());
      formData.append("location", $(form).find("[name='location']").val());
      formData.append("dealerId", $(form).find("[name='dealerId']").val());
      formData.append("ad_id", $(form).find("[name='ad_id']").val());
      formData.append("action", $(form).find("[name='action']").val());
      formData.append("form_type", $(form).find("[name='form_type']").val());
    }

    // form fields for new car
    if (form.name == "new_car_exform") {
      formData.append("make", $(form).find("[name='make']").val());
      // model field set
      var modelSelectVal = $(form).find("select[name='model']").val();
      // var modelInputVal = $(form).find("input[name='model']").val().trim();
      var modelInputVal = null;
      if (modelSelectVal && modelSelectVal.trim() !== "") {
        formData.append("model", modelSelectVal);
      } else if (modelInputVal && modelInputVal !== "") {
        formData.append("model", modelInputVal);
      }

      // Variant Field Selection
      var varientSelectVal = $(form).find("select[name='varient']").val();
      // var varientInputVal = $(form).find("input[name='varient']").val().trim();
      var varientInputVal = null;
      if (varientSelectVal && varientSelectVal.trim() !== "") {
        formData.append("varient", varientSelectVal);
      } else if (varientInputVal && varientInputVal !== "") {
        formData.append("varient", varientInputVal);
      }

      formData.append("year", $(form).find("[name='year']").val());
      formData.append("mileage", $(form).find("[name='mileage']").val());
      // formData.append("images[]", $(form).find("[name='images[]']").val());
      formData.append("location", $(form).find("[name='location']").val());
      formData.append("dealerId", $(form).find("[name='dealerId']").val());
      formData.append("message", $(form).find("[name='message']").val());
      formData.append(
        "seller_name",
        $(form).find("[name='seller_name']").val()
      );
      formData.append(
        "seller_email",
        $(form).find("[name='seller_email']").val()
      );
      formData.append(
        "seller_phone",
        $(form).find("[name='seller_phone']").val()
      );
      formData.append(
        "seller_pref_contact",
        $(form).find("[name='seller_pref_contact']").val()
      );
      formData.append(
        "seller_city",
        $(form).find("[name='seller_city']").val()
      );
      formData.append(
        "desired_make",
        $(form).find("select[name='desired_make']").val()
      );
      formData.append(
        "desired_model",
        $(form).find("select[name='desired_model']").val()
      );
      // for desired model
      // var desiredModelSelectVal = $(form)
      //   .find("select[name='desired_model']")
      //   .val();
      // var desiredModelInputVal = $(form)
      //   .find("input[name='desired_model']")
      //   .val()
      //   .trim();
      // if (desiredModelSelectVal && desiredModelSelectVal.trim() !== "") {
      //   formData.append("desired_model", desiredModelSelectVal);
      // } else if (desiredModelInputVal && desiredModelInputVal !== "") {
      //   formData.append("desired_model", desiredModelInputVal);
      // }
      formData.append(
        "desired_varient",
        $(form).find("select[name='desired_varient']").val()
      );
      // Variant Field Selection
      // var desiredVarientSelectVal = $(form).find("select[name='desired_varient']").val();
      // var desiredVarientInputVal = $(form).find("input[name='desired_varient']").val().trim();
      // if (desiredVarientSelectVal && desiredVarientSelectVal.trim() !== "") {
      //   formData.append("varient", desiredVarientSelectVal);
      // } else if (desiredVarientInputVal && desiredVarientInputVal !== "") {
      //   formData.append("varient", desiredVarientInputVal);
      // }
      formData.append(
        "desired_year",
        $(form).find("[name='desired_year']").val()
      );
      formData.append(
        "desired_message",
        $(form).find("[name='desired_message']").val()
      );
      formData.append(
        "seller_name",
        $(form).find("[name='seller_name']").val()
      );
      formData.append(
        "seller_email",
        $(form).find("[name='seller_email']").val()
      );
      formData.append(
        "seller_phone",
        $(form).find("[name='seller_phone']").val()
      );
      formData.append(
        "seller_pref_contact",
        $(form).find("[name='seller_pref_contact']").val()
      );
      formData.append(
        "seller_city",
        $(form).find("[name='seller_city']").val()
      );
      formData.append("action", $(form).find("[name='action']").val());
      formData.append("form_type", $(form).find("[name='form_type']").val());
    }

    // form fields to append in used sell car form
    if (form.name == "sellLeads") {
      formData.append("make", $(form).find("[name='make']").val());
      // model field set
      var modelSelectVal = $(form).find("select[name='model']").val();
      // var modelInputVal = $(form).find("input[name='model']").val()?.trim();
      var modelInputVal = null;
      if (modelSelectVal && modelSelectVal.trim() !== "") {
        formData.append("model", modelSelectVal);
      } else if (modelInputVal && modelInputVal !== "") {
        formData.append("model", modelInputVal);
      }

      // Variant Field Selection
      var varientSelectVal = $(form).find("select[name='varient']").val();
      // var varientInputVal = $(form).find("input[name='varient']").val()?.trim();
      var varientInputVal = null;
      if (varientSelectVal && varientSelectVal.trim() !== "") {
        formData.append("varient", varientSelectVal);
      } else if (varientInputVal && varientInputVal !== "") {
        formData.append("varient", varientInputVal);
      }

      formData.append("year", $(form).find("[name='year']").val());
      formData.append("mileage", $(form).find("[name='mileage']").val());
      formData.append("condition", $(form).find("[name='condition']").val());
      formData.append("location", $(form).find("[name='location']").val());
      formData.append("dealerId", $(form).find("[name='dealerId']").val());
      // formData.append("images[]", $(form).find("[name='images[]']").val());

      formData.append("message", $(form).find("[name='message']").val());
      formData.append(
        "seller_name",
        $(form).find("[name='seller_name']").val()
      );
      formData.append(
        "seller_email",
        $(form).find("[name='seller_email']").val()
      );
      formData.append(
        "seller_phone",
        $(form).find("[name='seller_phone']").val()
      );
      formData.append(
        "seller_pref_contact",
        $(form).find("[name='seller_pref_contact']").val()
      );
      formData.append(
        "seller_city",
        $(form).find("[name='seller_city']").val()
      );
      formData.append("action", $(form).find("[name='action']").val());
      formData.append("form_type", $(form).find("[name='form_type']").val());
    }

    const otpFormTypes = ["new_car_exform", "old_car_exform", "sell_form"];
    const currentFormType = formData.get("form_type");
    if (otpFormTypes.includes(currentFormType)) {
      startOtpFlow(form, formData, button, formTree, handleFormSubmit);
      return;
    }
    handleFormSubmit(formData);

    function handleFormSubmit(formDataToSend) {
      $.ajax({
        url: lmcl.ajax_url,
        type: "POST",
        data: formDataToSend,
        processData: false,
        contentType: false,
        success: function (response) {
          console.log(response);
          const data = response.data;
          button.querySelector(".spinner-overlay").style.display = "none";
          button.querySelector(".btn-text").style.display = "block";

          if (response.success) {
            form.reset();

            if (data && data.error.status === 0) {
              const successModal = new bootstrap.Modal(
                document.getElementById("successModal")
              );
              successModal.show();
            }
          } else {
            const errors = data?.errors;
            console.log(errors);
            errors.forEach((error) => {
              const toast = $(`
                  <div class="toast align-items-center text-bg-danger my-2 border-0" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                          <div class="toast-body text-white">
                              ${error}
                          </div>
                          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                      </div>
                  </div>
              `);

              $("#toast-container").append(toast);

              toast.toast({ delay: 5000 });
              toast.toast("show");

              toast.on("hidden.bs.toast", function () {
                $(this).remove();
              });
            });

            setTimeout(() => {
              $(formTree).find("#error-message").addClass("d-none");
            }, 5000);
          }
        },

        error: function (response) {
          $(formTree)
            .find("#error-message")
            .html(response.responseJSON.message)
            .removeClass("d-none");
          setTimeout(() => {
            $(formTree).find("#error-message").addClass("d-none");
          }, 5000);
          button.prop("disabled", false);
          button.find("#loading-spinner").addClass("d-none");
          button.find("span").removeClass("d-none");
        },
      });
    }
  });

  $(".search_pills_ul li button").on("click", function () {
    let arr = {
      buy: "buy-btn",
      exchange: "exchange-btn",
    };

    if ($(this).hasClass(arr["exchange"])) {
      $('input[name="search_type"]').val("exchange");
    } else {
      $('input[name="search_type"]').val("buy");
    }
  });

  //advanced search filter ajax requests

  let ajaxRequest;
  let isLoading = false;

  // Functions to show loader
  function showLoadingIndicator() {
    $(".spinner_wrapper").show();
    $(".spinner-overlay").show();
  }

  function hideLoadingIndicator() {
    $(".spinner_wrapper").hide();
    $(".spinner-overlay").hide();
  }

  const notFound = `<div class="text-center mt-5">
  <img alt="..." src="https://lmc-cpo.luckymotorcorp.com/app/uploads/2025/03/new-not-found-icon.svg" class="img-fluid" width="90" height="88"/>
  <h5 class="fw-bold text-center text-capitalize mt-3">No results found!</h5>
  <p class="text-dark text-opacity-75">Explore other filters or locations to discover more options</p>
  <button class="btn btn-primary btn-reset text-white rounded-0 mt-1 px-4 py-2 fw-medium"><span class="btn-text">Reset filters</span></button>
</div>`;

  $(document).ready(function () {
    // Using event delegation to handle dynamically added elements
    $(document).on("click", ".btn-reset", function () {
      $("input[type='checkbox']").prop("checked", false);

      filterType = "checkbox";

      ajaxRequest = filterRequest(
        null,
        null,
        null,
        null,
        null,
        "filter_query",
        filterType
      );
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const featuredFlag = urlParams.get("featured") === "1";

  function filterRequest(
    $search,
    $make,
    $model,
    $city,
    $dealer,
    $action,
    $filterType
  ) {
    return $.ajax({
      url: lmcl.ajax_url,
      type: "GET",
      data: {
        search: $search,
        make: $make,
        model: $model,
        city: $city,
        dealer: $dealer,
        filterType: $filterType,
        action: $action,
        featured: featuredFlag ? "1" : undefined,
      },
      beforeSend: function () {
        showLoadingIndicator();
      },
      success: function (response) {
        if (response.success && response.data.html) {
          const data = response.data;
          isLoading = false;
          hideLoadingIndicator();
          $(".row.filter_row").html(data.html).show();
          $(".listings-count").text(`${data.count} Results Found`);
          setTimeout(() => {
            $(".skeleton.skeleton-loader").hide();
            $(".card.product_card").show();
          }, 500);
        } else {
          hideLoadingIndicator();
          $(".row.filter_row").html(notFound).show();
        }
      },
      error: function () {
        hideLoadingIndicator();
        $(".row.filter_row").html(notFound).show();
      },
    });
  }

  function filterArr($search = "") {
    let search = $search;

    let make = $('input[name="adv_make[]"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get();
    let makeData = $('input[name="adv_make[]"]:checked')
      .map(function () {
        return $(this).attr("data-id");
      })
      .get();

    if (makeData.length > 0) {
      $(".model-items").show();

      $(".model").each(function () {
        const modelInfo = $(this);
        const modelId = modelInfo.attr("data-id");

        if (makeData.includes(modelId)) {
          modelInfo.removeClass("d-none").addClass("d-flex");
        } else {
          modelInfo.removeClass("d-flex").addClass("d-none");
        }
      });
    } else {
      $(".model-items").hide();
      $(".model").each(function () {
        $(this).removeClass("d-none").removeClass("d-flex");
      });
    }

    let model = $('input[name="adv_model[]"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get();

    let city = $('input[name="adv_city[]"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get();

    // Show and hide dealers based on city selection
    if (city.length > 0) {
      $(".dealer-items").show();

      $(".dealer").each(function () {
        const dealerInfo = $(this);

        const matchesCity = city.some((city) =>
          dealerInfo.hasClass(`city_${city}`)
        );
        if (matchesCity) {
          dealerInfo.removeClass("d-none").addClass("d-flex");
        } else {
          dealerInfo.removeClass("d-flex").addClass("d-none");
        }
      });
    } else {
      $(".dealer-items").hide();
      $(".dealer").each(function () {
        $(this).removeClass("d-none").removeClass("d-flex");
      });
    }

    let dealer = $('input[name="adv_dealer[]"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get();

    return {
      searchQuery: search,
      make: make,
      model: model,
      city: city,
      dealer: dealer,
    };
  }
  let filterType = null;

  $("#searchQuery").on("keyup", function () {
    // for making the filter button disabled and active
    if (
      $('#adv_filters input[type="checkbox"]:checked').length > 0 ||
      $("#searchQuery").val().trim() !== ""
    ) {
      $(".btn-filter").prop("disabled", false);
    } else {
      $(".btn-filter").prop("disabled", true);
    }
    const searchQuery = $(this).val();
    const { make, model, city, dealer } = filterArr(searchQuery);

    if (searchQuery.length < 3) {
      if (searchQuery === "") {
        if (ajaxRequest) {
          ajaxRequest.abort();
        }

        filterType = "all";

        ajaxRequest = filterRequest(
          "",
          make,
          model,
          city,
          dealer,
          "filter_query",
          filterType
        );
      }
      return;
    }

    if (ajaxRequest) {
      ajaxRequest.abort();
    }

    filterType = "search";

    ajaxRequest = filterRequest(
      searchQuery,
      make,
      model,
      city,
      dealer,
      "filter_query",
      filterType
    );
  });

  $('#adv_filters input[type="checkbox"]').on("click", function () {
    // for making the filter button disabled and active
    if ($('#adv_filters input[type="checkbox"]:checked').length > 0) {
      $(".btn-filter").prop("disabled", false);
    } else {
      $(".btn-filter").prop("disabled", true);
    }
    const { searchQuery, make, model, city, dealer } = filterArr(
      $("#searchQuery").val()
    );

    if (ajaxRequest) {
      ajaxRequest.abort();
    }

    filterType = "checkbox";

    ajaxRequest = filterRequest(
      searchQuery,
      make,
      model,
      city,
      dealer,
      "filter_query",
      filterType
    );
  });

  //************** Below code is to check the checkboxes based on the query parameter **************//

  // get the query from URL
  function getQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};

    params.make = urlParams.getAll("make[]");
    params.model = urlParams.getAll("model[]");
    params.city = urlParams.getAll("city[]");

    return params;
  }

  function setCheckboxesFromUrl() {
    const { make, model, city } = getQueryParams();

    // Check make checkboxes
    make.forEach((value) => {
      $(`input[name="adv_make[]"][value="${value}"]`).prop("checked", true);
    });

    // Check model checkboxes
    model.forEach((value) => {
      $(`input[name="adv_model[]"][value="${value}"]`).prop("checked", true);
    });

    // Check city checkboxes
    city.forEach((value) => {
      $(`input[name="adv_city[]"][value="${value}"]`).prop("checked", true);
    });
  }

  setCheckboxesFromUrl();

  // Trigger filter request if needed
  const { searchQuery, make, model, city, dealer } = filterArr();
  filterRequest(
    searchQuery,
    make,
    model,
    city,
    dealer,
    "filter_query",
    "checkbox"
  );

  // Featured-only toggle (full page reload, keeps existing params)
  $(document).on("change", ".adv-featured-filter", function () {
    const url = new URL(window.location.href);
    if (this.checked) {
      url.searchParams.set("featured", "1");
    } else {
      url.searchParams.delete("featured");
    }
    window.location.href = url.toString();
  });

  let makeId = null;
  let modelId = null;

  //************** Search Bar Script **************//
  makeId = "makeSelect";
  modelId = "modelSelect";

  $(".main_search_ul li button").on("click", function () {
    $('form[name="main_search_form"] select').val("");
    $('form[name="main_search_form"] select.commonModel option').addClass('d-none');
    $('form[name="main_search_form"] select.commonModel option[value=""]').removeClass('d-none');

    $('form[name="main_search_form"] select').selectpicker("refresh");

    let dataLink = $(this).data("link");
    let dataType = $(this).data("type");

    $(".search_bar_wrapper form").attr("action", dataLink);

    if (dataLink == "trade-in") {
      $("#condition_dropdown").removeClass("d-none");
      $("#city_dropdown").addClass("d-none");
    } else {
      $("#condition_dropdown").addClass("d-none");
      $("#city_dropdown").removeClass("d-none");
    }

    if (dataType == "buy-car") {
      $('input[name="type"]').val("buy-car");
      $('form[name="main_search_form"] button[type="submit"] span').text(
        "Search"
      );
    } else if (dataType == "sell-car") {
      $('input[name="type"]').val("sell-car");
      $('form[name="main_search_form"] button[type="submit"] span').text(
        "Continue"
      );
    } else {
      $('input[name="type"]').val("trade-in");
      $('form[name="main_search_form"] button[type="submit"] span').text(
        "Continue"
      );
    }
  });

  $("#condition_dropdown select").on("change", function () {
    let selectedValue = $(this).val();
    if (selectedValue == "old") {
      $(".search_bar_wrapper form").attr("action", "used-cars");
    } else {
      $(".search_bar_wrapper form").attr("action", "trade-in");
    }
  });

  $("form[name='main_search_form'] #make_dropdown select").on("change", function () {
    $("form[name='main_search_form'] #model_dropdown select").val("");
  });

  // end of search bar script

  const $_GET = {};
  const params = new URLSearchParams(window.location.search);

  params.forEach((value, key) => {
    if (key.endsWith("[]")) {
      const cleanKey = key.slice(0, -2);
      if (!$_GET[cleanKey]) {
        $_GET[cleanKey] = [];
      }
      $_GET[cleanKey].push(value);
    } else {
      $_GET[key] = value;
    }
  });

  function setupModelDropdown(
    makeId,
    modelId,
    varientId = null,
    wrapperId = null
  ) {

    console.log(modelId);

    const makeSelector = wrapperId
      ? $("#" + wrapperId + " " + "#" + makeId)
      : $("#" + makeId);
    const modelSelector = wrapperId
      ? $("#" + wrapperId + " " + "#" + modelId)
      : $("#" + modelId);

    console.log(modelSelector);
    const varientSelector = $("#" + varientId);

    // Refresh model dropdown initially
    modelSelector.selectpicker("refresh");

    // Handle pre-filled values from query params (if present)
    const queryParams = getQueryParams();

    if (modelId) {
      if (queryParams.make && queryParams.make.length > 0) {
        const makeValue = queryParams.make[0];
        const makeOption = $("#" + makeId + ' option[value="' + makeValue + '"]');
        const make_id = makeOption.data("id");

        // Filter the models based on parent make
        modelSelector.find("option").addClass("d-none");
        modelSelector
          .find('option[data-parent="' + make_id + '"]')
          .removeClass("d-none");

        if (queryParams.model[0]) {
          modelSelector.find('option[value="' + queryParams.model[0] + '"]').prop("selected", true);
        }

        modelSelector.selectpicker("refresh");
      }
    }

    if (varientId) {
      if (queryParams.model && queryParams.model.length > 0) {
        const modelValue = queryParams.model[0];
        const modelOption = modelSelector.find(
          'option[value="' + modelValue + '"]'
        );
        const model_id = modelOption.data("id");

        console.log("model " + modelValue);
        console.log("model ID " + model_id);

        // Filter the varient based on parent model
        varientSelector.find("option").addClass("d-none");
        varientSelector
          .find('option[data-parent="' + model_id + '"]')
          .removeClass("d-none");

        varientSelector.selectpicker("refresh");
      }
    }
  }

  setupModelDropdown("makeSelect", "modelSelect", null, "main_search_body"); // For search bar

  // For trade-in form
  setupModelDropdown(
    "desired_makeSelect",
    "desired_modelSelect",
    "varient",
    "trade_in_body"
  );
  setupModelDropdown('makeSelect', 'modelSelect', "varient", 'trade_in_body');

  // For used car form
  setupModelDropdown('makeSelect', 'modelSelect', "varient", 'sell_car_body');



  // Add event listener for make dropdown change
  $(".commonMake").on("change", function () {
    const selectedMakeId = $(this).find("option:selected").data("id");

    let crrForm = $(this).closest(".innerForm");
    let crrModel = crrForm.find('.commonModel');
    let crrVariant = crrForm.find('.commonVariant');
    console.log("Make Change");
    crrVariant
      .find("option")
      .addClass("d-none");
    crrVariant.val("")
      .find('option[value=""], option[value=" "]')
      .removeClass('d-none');

    crrModel
      .find("option")
      .addClass("d-none");
    crrModel.val("")
      .find('option[value=""], option[value=" "]')
      .removeClass('d-none');

    crrModel
      .find('option[data-parent="' + selectedMakeId + '"]')
      .removeClass("d-none");

    crrModel.selectpicker("refresh");
    crrVariant.selectpicker("refresh");
  });


  $(".commonModel").on("change", function () {
    const selectedModelId = $(this).find("option:selected").data("id");

    let crrForm = $(this).closest(".innerForm");
    let crrVariant = crrForm.find('.commonVariant');
    console.log("Model Change");
    crrVariant
      .find("option")
      .addClass("d-none");
    crrVariant.val("")
      .find('option[value=""], option[value=" "]')
      .removeClass('d-none');

    crrVariant
      .find('option[data-parent="' + selectedModelId + '"]')
      .removeClass("d-none");

    crrVariant.selectpicker("refresh");
  });


  ///onChange when city select then it refesh the dealers
  $(document).on('change', '.locationSelect', function () {
    const $form = $(this).closest('form');
    const $dealerSelect = $form.find('.dealerSelect');

    console.log('City changed. Resetting selected dealer only.');

    // Just reset the selected value and refresh — DO NOT touch the options
    $dealerSelect.val('').selectpicker('refresh');

    console.log('Dealer select value cleared and refreshed.');
  });

  $(".blog-archive__filter").on("click", function () {
    if (this.disabled) {
      return;
    }
    const target = $(this).data("target");
    if (target) {
      window.location.href = target;
    }
  });

  $("[data-blog-load-more]").on("click", function () {
    const $btn = $(this);
    if ($btn.data("loading")) {
      return;
    }

    const currentPage = parseInt($btn.data("page"), 10) || 1;
    const perPage = parseInt($btn.data("perPage"), 10) || 9;
    const nonce = $btn.data("nonce");
    const category = $btn.data("category") || "";

    $btn.data("loading", true);
    $btn.find(".btn-text").text("Loading...");
    $btn.find(".spinner-border").removeClass("d-none");

    $.ajax({
      url: lmcl.ajax_url,
      type: "POST",
      dataType: "json",
      data: {
        action: "lmcl_load_more_posts",
        page: currentPage + 1,
        per_page: perPage,
        category: category,
        nonce: nonce,
      },
      success: function (response) {
        if (response.success && response.data?.html) {
          $(".blog-archive__grid").append(response.data.html);
          $btn.data("page", currentPage + 1);

          if (!response.data.has_more) {
            $btn.closest(".blog-archive__load-more").fadeOut(200, function () {
              $(this).remove();
            });
          }
        } else {
          console.error(response.data?.message || "Unable to load more posts.");
        }
      },
      error: function () {
        console.error("Failed to load more posts.");
      },
      complete: function () {
        $btn.data("loading", false);
        $btn.find(".btn-text").text("Load more");
        $btn.find(".spinner-border").addClass("d-none");
      },
    });
  });
})(jQuery);
